// import { ErrorBoundary } from "react-error-boundary";
import { useGamePlay } from "../../../redux/gamePlay";
import { useMemo } from "react";
// import {
//   ERROR_PLAYER,
//   sendPingData,
//   setError,
//   setErrorMsg,
// } from "../../../ducks/ping";
import Player from "./Player";
import OpponentTime from "./OpponentTime";
import { getCapturedMaterial } from "../gamePlayMoves";
export default function OpponentPlayer() {
  const {
    gameEnded,
    isUserTurn,
    opponent,
    moves,
    positions,
    positionIndex,
    playingWhite,
  } = useGamePlay();

  const isUser = false;
  const capturedMaterial = useMemo(
    () => getCapturedMaterial(moves, positions?.[0], positionIndex),
    [moves, positions, positionIndex]
  );
  const opponentMaterial = playingWhite
    ? capturedMaterial.black
    : capturedMaterial.white;
  const playerProps = {
    isUser,
    ...opponent,
    gameEnded,
    turn: !isUserTurn,
    capturedPieces: opponentMaterial.capturedPieces,
    materialAdvantage: opponentMaterial.materialAdvantage,
  };

  return (
    // <ErrorBoundary
    //   fallbackRender={({ error, resetErrorBoundary }) => null}
    //   onError={(error, info: { componentStack: string }) => {
    //     setError(ERROR_PLAYER);
    //     setErrorMsg({
    //       errorMsg:
    //         "OpponentPlayer4 " +
    //         error.message +
    //         " " +
    //         JSON.stringify(playerProps),
    //       componentStack: info.componentStack,
    //     });
    //     sendPingData();
    //   }}
    // >
    <Player {...playerProps}>
      <OpponentTime isRunning={!isUserTurn} />
    </Player>
    // </ErrorBoundary>
  );
}
